// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__1Cmbi","wrapper":"Content_wrapper__3HHk2","fadeIn":"Content_fadeIn__35EON","fadeOut":"Content_fadeOut__3SruL"};